var render = function render(){
  var _vm$blok$caption;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "container",
    staticClass: "mt-12 md:-mt-4 xl:mt-4"
  }, [_c('div', {
    staticClass: "flex justify-center -mb-3 md:-mb-7 xl:-mb-3"
  }, [_c('svg', {
    staticClass: "min-w-[800px] md:min-w-[100%]",
    attrs: {
      "width": "924",
      "height": "160",
      "viewBox": "0 0 924 160",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "opacity": "0.7"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask0_4887_39991",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "-1",
      "width": "924",
      "height": "161"
    }
  }, [_c('rect', {
    attrs: {
      "y": "-0.000488281",
      "width": "924",
      "height": "160",
      "fill": "#C4C4C4"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#mask0_4887_39991)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M458.478 145.431C357.819 145.431 260.21 130.355 180.249 102.485C100.505 74.6141 42.9856 35.5359 17.0582 -8.69983C-8.86923 -52.9355 -2.33292 -99.8492 36.2314 -142.101C74.7958 -184.353 142.774 -219.762 229.925 -242.673C317.076 -265.584 385.054 -300.893 423.618 -343.245C462.182 -385.596 462.4 -430.327 462.4 -476.646",
      "stroke": "url(#paint0_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.618 -476.746C462.618 -430.428 462.4 -385.597 426.886 -343.345C391.372 -300.994 328.841 -265.684 248.663 -242.773C168.484 -219.862 105.953 -184.553 70.4388 -142.201C34.9248 -99.8502 28.8242 -53.0358 52.7907 -8.80008C76.7572 35.4356 129.484 74.5138 202.908 102.384C276.333 130.255 366.316 145.331 458.914 145.331",
      "stroke": "url(#paint1_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.62 -476.746C462.62 -430.428 462.402 -385.597 429.939 -343.345C397.693 -300.994 340.391 -265.684 267.184 -242.773C193.977 -219.862 136.893 -184.553 104.43 -142.201C71.9658 -99.8502 66.5188 -53.0358 88.3066 -8.80008C110.094 35.4356 158.463 74.5138 225.352 102.384C292.458 130.255 374.598 145.331 458.916 145.331",
      "stroke": "url(#paint2_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.609 -476.746C462.609 -430.428 462.391 -385.597 433.195 -343.345C404 -300.994 352.145 -265.684 285.91 -242.773C219.675 -219.862 168.038 -184.553 138.625 -142.201C109.429 -99.8502 104.2 -53.0358 124.027 -8.80008C143.854 35.4356 187.429 74.5138 247.999 102.384C308.569 130.255 382.865 145.331 459.34 145.331",
      "stroke": "url(#paint3_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.617 -476.747C462.617 -430.428 462.399 -385.597 436.253 -343.345C410.108 -300.994 363.7 -265.685 304.437 -242.773C245.175 -219.862 198.985 -184.553 172.621 -142.202C146.476 -99.8505 141.901 -53.036 159.549 -8.80033C177.197 35.4354 216.197 74.5136 270.448 102.384C324.7 130.255 391.153 145.33 459.566 145.33",
      "stroke": "url(#paint4_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.624 -476.747C462.624 -430.428 462.406 -385.597 439.311 -343.345C416.216 -300.994 375.473 -265.685 323.183 -242.773C270.892 -219.862 230.149 -184.553 207.054 -142.202C183.959 -99.8505 179.819 -53.036 195.506 -8.80033C211.193 35.4354 245.618 74.5136 293.333 102.384C341.266 130.255 399.875 145.33 460.228 145.33",
      "stroke": "url(#paint5_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.615 -476.747C462.615 -430.428 462.397 -385.597 442.352 -343.345C422.307 -300.994 387.011 -265.685 341.693 -242.773C296.374 -219.862 261.078 -184.553 241.033 -142.202C220.989 -99.8505 217.502 -53.036 231.011 -8.80033C244.519 35.4354 274.369 74.5136 315.983 102.384C357.38 130.255 408.363 145.33 460.654 145.33",
      "stroke": "url(#paint6_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.62 -476.746C462.62 -430.428 462.402 -385.597 445.625 -343.345C428.631 -300.994 398.781 -265.685 360.435 -242.773C322.089 -219.862 292.239 -184.553 275.245 -142.201C258.25 -99.8502 255.418 -53.0358 266.748 -8.80008C278.295 35.4356 303.351 74.5138 338.647 102.384C373.726 130.255 416.865 145.331 461.094 145.331",
      "stroke": "url(#paint7_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.616 -476.746C462.616 -430.428 462.398 -385.597 448.672 -343.345C434.727 -300.994 410.325 -265.685 378.951 -242.773C347.576 -219.862 323.174 -184.553 309.23 -142.201C295.286 -99.8502 292.889 -53.0358 302.258 -8.80008C311.626 35.4356 332.325 74.5138 361.085 102.384C389.845 130.255 424.923 145.331 461.308 145.331",
      "stroke": "url(#paint8_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.832 -476.746C462.832 -430.428 462.832 -385.597 451.939 -343.345C441.263 -300.994 422.089 -265.685 397.687 -242.773C373.285 -219.862 354.329 -184.553 343.435 -142.201C332.759 -99.8502 330.798 -53.0358 337.988 -8.80009C345.178 35.4356 361.301 74.5138 383.743 102.384C406.184 130.255 433.419 145.331 461.525 145.331",
      "stroke": "url(#paint9_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.836 -476.747C462.836 -430.428 462.836 -385.597 454.993 -343.345C447.367 -300.994 433.641 -265.685 416.21 -242.773C398.78 -219.862 385.272 -184.553 377.428 -142.202C369.585 -99.8505 368.277 -53.036 373.506 -8.80033C378.735 35.4354 390.283 74.5135 406.188 102.384C422.093 130.255 441.702 145.33 461.747 145.33",
      "stroke": "url(#paint10_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.828 -476.747C462.828 -430.428 462.828 -385.597 458.253 -343.345C453.677 -300.994 445.398 -265.685 434.94 -242.773C424.482 -219.862 416.42 -184.553 411.627 -142.202C406.834 -99.8505 406.18 -53.036 409.23 -8.80033C412.28 35.4354 419.253 74.5135 428.839 102.384C438.426 130.254 450.191 145.33 462.174 145.33",
      "stroke": "url(#paint11_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.844 -476.747C462.844 -430.428 462.844 -385.597 461.319 -343.345C459.794 -300.994 456.962 -265.685 453.475 -242.773C449.989 -219.862 447.375 -184.553 445.632 -142.202C444.107 -99.8505 443.889 -53.036 444.76 -8.80033C445.85 35.4354 448.029 74.5135 451.297 102.384C454.565 130.254 458.487 145.33 462.408 145.33",
      "stroke": "url(#paint12_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 462.835 -385.597 464.36 -343.345C465.885 -300.994 468.717 -265.685 472.203 -242.773C475.689 -219.862 478.304 -184.553 480.047 -142.202C481.572 -99.8505 481.79 -53.036 480.919 -8.80033C479.829 35.4354 477.65 74.5135 474.382 102.384C471.114 130.254 467.192 145.33 463.27 145.33",
      "stroke": "url(#paint13_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 462.835 -385.597 467.41 -343.345C471.986 -300.994 480.265 -265.685 490.723 -242.773C501.181 -219.862 509.243 -184.553 514.036 -142.202C518.829 -99.8505 519.483 -53.036 516.433 -8.80032C513.382 35.4354 506.41 74.5136 496.824 102.384C487.237 130.254 475.472 145.33 463.488 145.33",
      "stroke": "url(#paint14_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 462.835 -385.597 470.678 -343.345C478.304 -300.994 492.03 -265.685 509.461 -242.773C526.891 -219.862 540.399 -184.553 548.243 -142.202C556.086 -99.8505 557.394 -53.036 552.165 -8.80031C546.935 35.4354 535.388 74.5136 519.483 102.384C503.578 130.255 483.969 145.33 463.924 145.33",
      "stroke": "url(#paint15_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 462.835 -385.597 473.729 -343.345C484.405 -300.994 503.578 -265.685 527.98 -242.773C552.382 -219.862 571.338 -184.553 582.232 -142.202C592.908 -99.8505 594.869 -53.036 587.679 -8.8003C580.489 35.4354 564.366 74.5136 541.924 102.384C519.483 130.255 492.248 145.33 464.142 145.33",
      "stroke": "url(#paint16_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 463.053 -385.597 476.779 -343.345C490.723 -300.994 515.125 -265.685 546.5 -242.773C577.874 -219.862 602.276 -184.553 616.221 -142.202C630.165 -99.8504 632.561 -53.036 623.193 -8.80029C613.824 35.4354 593.125 74.5136 564.366 102.384C535.606 130.255 500.527 145.33 464.142 145.33",
      "stroke": "url(#paint17_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 463.053 -385.597 479.829 -343.345C496.824 -300.994 526.673 -265.685 565.019 -242.773C603.366 -219.862 633.215 -184.553 650.209 -142.202C667.204 -99.8504 670.036 -53.036 658.707 -8.80028C647.159 35.4354 622.103 74.5136 586.807 102.384C551.729 130.255 508.589 145.33 464.36 145.33",
      "stroke": "url(#paint18_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 463.053 -385.597 483.097 -343.345C503.142 -300.994 538.438 -265.685 583.757 -242.773C629.075 -219.862 664.371 -184.553 684.416 -142.202C704.461 -99.8504 707.947 -53.036 694.439 -8.80027C680.93 35.4354 651.081 74.5136 609.466 102.384C568.07 130.255 517.086 145.33 464.796 145.33",
      "stroke": "url(#paint19_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 463.053 -385.597 486.148 -343.345C509.243 -300.994 549.986 -265.685 602.276 -242.773C654.567 -219.862 695.31 -184.553 718.405 -142.202C741.5 -99.8504 745.64 -53.036 729.953 -8.80026C714.265 35.4354 679.841 74.5136 632.126 102.384C584.193 130.255 525.583 145.33 465.231 145.33",
      "stroke": "url(#paint20_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 463.053 -385.597 489.198 -343.345C515.343 -300.994 561.751 -265.685 621.014 -242.773C680.277 -219.862 726.467 -184.553 752.83 -142.202C778.975 -99.8504 783.551 -53.0359 765.902 -8.80025C748.254 35.4354 709.254 74.5136 655.003 102.384C600.751 130.255 534.299 145.33 465.885 145.33",
      "stroke": "url(#paint21_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 463.053 -385.597 492.248 -343.345C521.444 -300.994 573.299 -265.685 639.533 -242.773C705.768 -219.862 757.405 -184.553 786.819 -142.202C816.232 -99.8504 821.243 -53.0359 801.416 -8.80024C781.59 35.4354 738.014 74.5136 677.444 102.384C616.874 130.255 542.578 145.33 466.103 145.33",
      "stroke": "url(#paint22_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 463.053 -385.597 495.516 -343.345C527.762 -300.994 585.064 -265.685 658.271 -242.773C731.478 -219.862 788.562 -184.553 821.025 -142.202C853.489 -99.8504 858.936 -53.0359 837.148 -8.80024C815.361 35.4355 766.992 74.5136 700.103 102.384C632.997 130.255 550.857 145.33 466.539 145.33",
      "stroke": "url(#paint23_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 463.053 -385.597 498.567 -343.345C534.081 -300.994 596.611 -265.685 676.79 -242.773C756.969 -219.862 819.5 -184.553 855.014 -142.202C890.528 -99.8504 896.629 -53.0359 872.662 -8.80023C848.696 35.4355 795.969 74.5136 722.545 102.384C649.12 130.255 559.136 145.33 466.539 145.33",
      "stroke": "url(#paint24_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 -476.747C462.835 -430.428 463.27 -385.597 501.617 -343.345C540.181 -300.994 608.159 -265.685 695.31 -242.773C782.461 -219.862 850.439 -184.553 889.003 -142.202C927.568 -99.8504 934.322 -53.0359 908.177 -8.80022C882.249 35.4355 824.73 74.5136 744.986 102.384C665.243 130.255 567.416 145.33 466.756 145.33",
      "stroke": "url(#paint25_linear_4887_39991)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_4887_39991",
      "x1": "231.95",
      "y1": "-476.646",
      "x2": "231.95",
      "y2": "145.431",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear_4887_39991",
      "x1": "250.52",
      "y1": "-476.746",
      "x2": "250.52",
      "y2": "145.331",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint2_linear_4887_39991",
      "x1": "268.92",
      "y1": "-476.746",
      "x2": "268.92",
      "y2": "145.331",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint3_linear_4887_39991",
      "x1": "287.4",
      "y1": "-476.746",
      "x2": "287.4",
      "y2": "145.331",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint4_linear_4887_39991",
      "x1": "305.807",
      "y1": "-476.747",
      "x2": "305.806",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint5_linear_4887_39991",
      "x1": "324.384",
      "y1": "-476.747",
      "x2": "324.383",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint6_linear_4887_39991",
      "x1": "342.773",
      "y1": "-476.747",
      "x2": "342.772",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint7_linear_4887_39991",
      "x1": "361.285",
      "y1": "-476.746",
      "x2": "361.285",
      "y2": "145.331",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint8_linear_4887_39991",
      "x1": "379.632",
      "y1": "-476.746",
      "x2": "379.632",
      "y2": "145.331",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint9_linear_4887_39991",
      "x1": "398.279",
      "y1": "-476.746",
      "x2": "398.278",
      "y2": "145.331",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint10_linear_4887_39991",
      "x1": "416.603",
      "y1": "-476.747",
      "x2": "416.602",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint11_linear_4887_39991",
      "x1": "435.102",
      "y1": "-476.747",
      "x2": "435.102",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint12_linear_4887_39991",
      "x1": "453.547",
      "y1": "-476.747",
      "x2": "453.547",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint13_linear_4887_39991",
      "x1": "472.132",
      "y1": "-476.747",
      "x2": "472.131",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint14_linear_4887_39991",
      "x1": "490.561",
      "y1": "-476.747",
      "x2": "490.561",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint15_linear_4887_39991",
      "x1": "509.068",
      "y1": "-476.747",
      "x2": "509.068",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint16_linear_4887_39991",
      "x1": "527.389",
      "y1": "-476.747",
      "x2": "527.388",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint17_linear_4887_39991",
      "x1": "545.818",
      "y1": "-476.747",
      "x2": "545.818",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint18_linear_4887_39991",
      "x1": "564.17",
      "y1": "-476.747",
      "x2": "564.17",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint19_linear_4887_39991",
      "x1": "582.677",
      "y1": "-476.747",
      "x2": "582.677",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint20_linear_4887_39991",
      "x1": "601.076",
      "y1": "-476.747",
      "x2": "601.075",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint21_linear_4887_39991",
      "x1": "619.645",
      "y1": "-476.747",
      "x2": "619.645",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint22_linear_4887_39991",
      "x1": "638.075",
      "y1": "-476.747",
      "x2": "638.074",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint23_linear_4887_39991",
      "x1": "656.535",
      "y1": "-476.747",
      "x2": "656.535",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint24_linear_4887_39991",
      "x1": "674.933",
      "y1": "-476.747",
      "x2": "674.933",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint25_linear_4887_39991",
      "x1": "693.332",
      "y1": "-476.747",
      "x2": "693.332",
      "y2": "145.33",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center relative"
  }, [((_vm$blok$caption = _vm.blok.caption) === null || _vm$blok$caption === void 0 ? void 0 : _vm$blok$caption.length) > 0 ? _c('div', {
    staticClass: "absolute flex flex-col md:flex-row xl:flex-col justify-between xl:justify-start w-full caption -bottom-52 md:-bottom-24 xl:bottom-0 xl:top-1/2 xl:transform xl:-translate-y-1/2 left-0"
  }, _vm._l(_vm.blok.caption, function (captionBlok) {
    return _c('StoryblokComponent', {
      key: captionBlok._uid,
      attrs: {
        "blok": captionBlok
      }
    });
  }), 1) : _vm._e(), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "354",
      "height": "354",
      "viewBox": "0 0 354 354",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M177 353.999C274.754 353.999 354 274.753 354 176.999C354 79.2446 274.754 -0.000976562 177 -0.000976562C79.2456 -0.000976562 0 79.2446 0 176.999C0 274.753 79.2456 353.999 177 353.999Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "seal-rings"
  }, [_c('path', {
    attrs: {
      "d": "M177 346.713C162.107 346.713 147.321 344.785 133.071 340.97C118.757 337.135 104.979 331.435 92.1214 323.999C79.3071 316.585 67.4786 307.499 57 296.999C46.5 286.499 37.4143 274.692 30 261.878C22.5643 249.02 16.8429 235.242 13.0286 220.928C9.21429 206.678 7.28572 191.892 7.28572 176.999C7.28572 162.106 9.21429 147.32 13.0286 133.07C16.8643 118.756 22.5643 104.978 30 92.1205C37.4143 79.3062 46.5 67.4776 57 56.9991C67.5 46.4991 79.3071 37.4134 92.1214 29.9991C104.979 22.5634 118.757 16.8419 133.071 13.0276C147.321 9.21336 162.107 7.28479 177 7.28479C191.893 7.28479 206.679 9.21336 220.929 13.0276C235.243 16.8634 249.021 22.5634 261.879 29.9991C274.693 37.4134 286.521 46.4991 297 56.9991C307.5 67.4991 316.586 79.3062 324 92.1205C331.436 104.978 337.157 118.756 340.971 133.07C344.786 147.32 346.714 162.106 346.714 176.999C346.714 191.892 344.786 206.678 340.971 220.928C337.136 235.242 331.436 249.02 324 261.878C316.586 274.692 307.5 286.52 297 296.999C286.5 307.499 274.693 316.585 261.879 323.999C249.021 331.435 235.243 337.156 220.929 340.97C206.679 344.785 191.893 346.713 177 346.713ZM177 19.2848C163.157 19.2848 149.421 21.0848 136.157 24.6205C122.871 28.1776 110.057 33.4705 98.1214 40.3919C86.2071 47.2919 75.2143 55.7348 65.4643 65.4848C55.7143 75.2348 47.2714 86.2276 40.3929 98.1419C33.4929 110.078 28.1786 122.87 24.6214 136.178C21.0857 149.42 19.2857 163.156 19.2857 176.999C19.2857 190.842 21.0857 204.578 24.6214 217.842C28.1786 231.128 33.4714 243.942 40.3929 255.878C47.2929 267.792 55.7357 278.785 65.4857 288.535C75.2357 298.285 86.2286 306.728 98.1429 313.628C110.079 320.528 122.871 325.842 136.179 329.399C149.421 332.935 163.157 334.735 177.021 334.735C190.886 334.735 204.6 332.935 217.864 329.399C231.15 325.842 243.964 320.549 255.9 313.628C267.814 306.728 278.807 298.285 288.557 288.535C298.307 278.785 306.75 267.792 313.65 255.878C320.55 243.942 325.864 231.149 329.421 217.842C332.957 204.599 334.757 190.863 334.757 176.999C334.757 163.135 332.957 149.421 329.421 136.156C325.864 122.871 320.571 110.056 313.65 98.1205C306.75 86.2062 298.307 75.2134 288.557 65.4634C278.807 55.7134 267.814 47.2705 255.9 40.3705C243.964 33.4705 231.171 28.1562 217.864 24.5991C204.579 21.0848 190.843 19.2848 177 19.2848Z",
      "fill": "#DEDEE5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M177 330.213C164.293 330.213 151.671 328.649 139.436 325.585C138.279 325.285 137.571 324.106 137.893 322.949L139.886 315.492C140.186 314.356 141.343 313.692 142.479 313.97C153.707 316.799 165.3 318.213 177 318.213C189.407 318.213 201.707 316.606 213.557 313.435C225.45 310.263 236.914 305.506 247.607 299.313C258.279 293.142 268.114 285.578 276.836 276.856C285.064 268.628 292.264 259.413 298.221 249.449C298.821 248.442 300.129 248.099 301.136 248.699L307.821 252.556C308.85 253.156 309.193 254.485 308.593 255.513C302.1 266.356 294.279 276.385 285.321 285.363C275.85 294.835 265.179 303.042 253.607 309.728C241.993 316.435 229.564 321.599 216.643 325.049C203.786 328.478 190.436 330.213 177 330.213Z",
      "fill": "#DEDEE5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M328.05 176.999H320.336C319.157 176.999 318.214 176.056 318.193 174.899C318.021 163.22 316.414 151.628 313.436 140.442C310.264 128.528 305.507 117.085 299.314 106.392C293.143 95.7204 285.579 85.8847 276.857 77.1632C268.629 68.9347 259.414 61.7346 249.45 55.7775C248.443 55.1775 248.1 53.8704 248.7 52.8632L252.557 46.1775C253.157 45.1489 254.486 44.8061 255.514 45.4061C266.357 51.8989 276.386 59.7204 285.364 68.6775C294.836 78.1489 303.043 88.8204 309.729 100.392C316.436 112.006 321.6 124.435 325.05 137.356C328.307 149.528 330.043 162.128 330.214 174.835C330.214 176.013 329.25 176.999 328.05 176.999Z",
      "fill": "#DEDEE5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M38.5071 139.885L31.05 137.892C29.8928 137.592 29.2071 136.392 29.5286 135.235C32.9786 123.063 37.9286 111.342 44.2714 100.37C50.9571 88.799 59.1643 78.1276 68.6357 68.6561C78.1071 59.1847 88.7786 50.9776 100.35 44.2918C111.964 37.5847 124.393 32.4204 137.314 28.9704C149.486 25.7133 162.086 23.9776 174.793 23.8061C175.993 23.7847 176.957 24.749 176.957 25.949V33.6633C176.957 34.8419 176.014 35.7847 174.857 35.8061C163.179 35.9776 151.586 37.5847 140.4 40.5633C128.507 43.7347 117.043 48.4919 106.35 54.6847C95.7214 60.8561 85.8857 68.399 77.1428 77.1418C68.4 85.8847 60.8571 95.7204 54.6857 106.37C48.8571 116.442 44.2928 127.22 41.1214 138.385C40.8 139.52 39.6428 140.185 38.5071 139.885Z",
      "fill": "#DEDEE5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M177 313.713C165 313.713 153.086 312.149 141.621 309.085C130.093 305.999 118.993 301.392 108.643 295.413C98.9572 289.799 89.9572 283.006 81.9 275.206C81.0429 274.37 81.0215 272.999 81.8786 272.142L87.3429 266.678C88.1786 265.842 89.5072 265.842 90.3429 266.656C97.6715 273.749 105.857 279.92 114.664 285.02C124.114 290.485 134.229 294.685 144.729 297.492C155.207 300.299 166.071 301.713 177.021 301.713C187.971 301.713 198.836 300.299 209.314 297.492C219.15 294.856 228.643 291.02 237.557 286.07C238.586 285.492 239.871 285.856 240.45 286.863L244.307 293.549C244.907 294.578 244.543 295.906 243.493 296.506C233.679 301.97 223.243 306.213 212.4 309.106C200.914 312.149 189 313.713 177 313.713Z",
      "fill": "#DEDEE5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M293.55 244.285L286.864 240.428C285.857 239.849 285.493 238.563 286.071 237.535C291.021 228.621 294.879 219.128 297.493 209.292C300.3 198.813 301.714 187.949 301.714 176.999C301.714 166.756 300.472 156.599 298.029 146.742C297.75 145.606 298.414 144.449 299.55 144.149L307.007 142.156C308.164 141.856 309.343 142.542 309.643 143.699C312.343 154.52 313.714 165.706 313.714 176.978C313.714 188.978 312.15 200.892 309.086 212.356C306.193 223.178 301.95 233.635 296.486 243.449C295.907 244.521 294.579 244.885 293.55 244.285Z",
      "fill": "#DEDEE5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M266.679 87.3204C265.843 88.1561 264.514 88.1561 263.679 87.3418C256.35 80.249 248.164 74.0775 239.357 68.9775C229.907 63.5132 219.793 59.3132 209.293 56.5061C198.814 53.699 187.95 52.2847 177 52.2847C166.05 52.2847 155.186 53.699 144.707 56.5061C134.871 59.1418 125.379 62.9775 116.464 67.9275C115.436 68.5061 114.15 68.1418 113.571 67.1347L109.714 60.449C109.114 59.4204 109.479 58.0918 110.529 57.4918C120.343 52.0275 130.779 47.7847 141.621 44.8918C153.086 41.849 165 40.2847 177 40.2847C189 40.2847 200.914 41.849 212.379 44.9132C223.907 47.999 235.007 52.6061 245.357 58.5847C255.043 64.199 264.043 70.9918 272.1 78.7918C272.957 79.6275 272.979 80.999 272.121 81.8561L266.679 87.3204Z",
      "fill": "#DEDEE5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M46.9928 211.82C45.8357 212.12 44.6571 211.435 44.3571 210.277C41.6571 199.456 40.2857 188.27 40.2857 176.999C40.2857 164.999 41.85 153.085 44.9143 141.62C47.8071 130.799 52.05 120.342 57.5143 110.527C58.0928 109.477 59.4214 109.113 60.4714 109.713L67.1571 113.57C68.1643 114.149 68.5286 115.435 67.95 116.463C63 125.377 59.1428 134.87 56.5286 144.706C53.7 155.185 52.2857 166.049 52.2857 176.999C52.2857 187.242 53.5286 197.399 55.9714 207.256C56.25 208.392 55.5857 209.549 54.45 209.849L46.9928 211.82Z",
      "fill": "#DEDEE5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.3929 148.435L62.9358 146.442C61.7786 146.142 61.0929 144.942 61.4358 143.785C64.1358 134.399 67.9715 125.356 72.8786 116.87C78.1286 107.785 84.5572 99.4275 91.9929 91.9918C99.4286 84.5561 107.807 78.1275 116.872 72.8775C125.979 67.6061 135.729 63.5561 145.886 60.8561C155.979 58.1561 166.457 56.7847 177 56.7847C186.814 56.7847 196.564 57.9632 206.014 60.299C207.172 60.5775 207.879 61.7775 207.557 62.9347L205.564 70.3918C205.264 71.5275 204.107 72.1918 202.972 71.9132C194.529 69.8347 185.786 68.7847 177 68.7847C167.507 68.7847 158.079 70.0061 148.971 72.449C139.843 74.8918 131.079 78.5347 122.872 83.2704C114.707 88.0061 107.164 93.7918 100.457 100.478C93.7715 107.163 87.9644 114.706 83.2501 122.892C78.8572 130.478 75.4072 138.556 72.9858 146.956C72.6858 148.07 71.5286 148.735 70.3929 148.435Z",
      "fill": "#DEDEE5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M177 297.213C167.186 297.213 157.436 296.035 147.986 293.699C146.829 293.42 146.121 292.22 146.443 291.063L148.436 283.606C148.736 282.47 149.893 281.806 151.029 282.085C159.493 284.163 168.214 285.213 177 285.213C186.493 285.213 195.921 283.992 205.029 281.549C214.157 279.106 222.921 275.463 231.129 270.728C239.293 265.992 246.836 260.206 253.543 253.52C260.229 246.835 266.036 239.292 270.75 231.106C275.143 223.52 278.593 215.442 281.014 207.042C281.336 205.928 282.493 205.263 283.629 205.563L291.086 207.556C292.243 207.856 292.929 209.056 292.586 210.213C289.886 219.599 286.05 228.642 281.143 237.128C275.893 246.213 269.464 254.57 262.029 262.006C254.593 269.442 246.214 275.87 237.15 281.12C228.043 286.392 218.293 290.442 208.136 293.142C198.021 295.842 187.543 297.213 177 297.213Z",
      "fill": "#DEDEE5"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110.293 158.785C111.536 158.785 112.779 159.642 113.143 160.885L119.936 182.678L126.557 160.713C126.879 159.578 128.014 158.763 129.15 158.763H131.421C132.6 158.763 133.736 159.578 134.057 160.713L140.743 182.678L147.471 160.885C147.793 159.642 149.036 158.785 150.321 158.785H153.771C155.014 158.785 155.657 159.706 155.229 160.885L144.407 193.263C144.021 194.335 142.907 195.213 141.707 195.213H139.436C138.3 195.213 137.164 194.399 136.843 193.263L130.329 172.263L123.75 193.263C123.429 194.399 122.293 195.213 121.114 195.213H118.843C117.707 195.213 116.571 194.356 116.207 193.263L105.321 160.885C104.893 159.706 105.536 158.785 106.821 158.785H110.293Z",
      "fill": "#3D3E46"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M162.321 158.785H184.886C186.171 158.785 187.093 159.706 187.093 160.992V163.692C187.093 164.935 186.171 165.899 184.886 165.899H167.807V173.292H181.971C183.214 173.292 184.179 174.213 184.179 175.456V178.156C184.179 179.442 183.214 180.363 181.971 180.363H167.807V188.142H185.143C186.429 188.142 187.35 189.063 187.35 190.306V193.006C187.35 194.249 186.429 195.213 185.143 195.213H162.321C161.079 195.213 160.114 194.249 160.114 193.006V160.992C160.114 159.706 161.079 158.785 162.321 158.785Z",
      "fill": "#3D3E46"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M194.893 158.785H198.171C199.414 158.785 200.379 159.706 200.379 160.992V188.142H216.043C217.286 188.142 218.25 189.063 218.25 190.306V193.006C218.25 194.249 217.286 195.213 216.043 195.213H194.893C193.65 195.213 192.686 194.249 192.686 193.006V160.992C192.686 159.706 193.65 158.785 194.893 158.785Z",
      "fill": "#3D3E46"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.407 158.785H228.686C229.929 158.785 230.893 159.706 230.893 160.992V188.142H246.557C247.8 188.142 248.764 189.063 248.764 190.306V193.006C248.764 194.249 247.8 195.213 246.557 195.213H225.407C224.164 195.213 223.2 194.249 223.2 193.006V160.992C223.2 159.706 224.186 158.785 225.407 158.785Z",
      "fill": "#3D3E46"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hidden md:flex justify-center md:-mt-7 xl:-mt-3"
  }, [_c('svg', {
    attrs: {
      "width": "924",
      "height": "166",
      "viewBox": "0 0 924 166",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "opacity": "0.7"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask0_4887_39962",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "-1",
      "width": "924",
      "height": "167"
    }
  }, [_c('rect', {
    attrs: {
      "width": "924",
      "height": "166",
      "transform": "matrix(1 0 0 -1 0 166)",
      "fill": "#C4C4C4"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#mask0_4887_39962)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M458.478 14.5681C357.819 14.5681 260.21 29.644 180.249 57.5144C100.505 85.3849 42.9856 124.463 17.0582 168.699C-8.86923 212.935 -2.33292 259.848 36.2314 302.1C74.7958 344.352 142.774 379.761 229.925 402.672C317.076 425.583 385.054 460.892 423.618 503.244C462.182 545.595 462.4 590.326 462.4 636.645",
      "stroke": "url(#paint0_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.618 636.745C462.618 590.427 462.4 545.596 426.886 503.344C391.372 460.993 328.841 425.684 248.663 402.772C168.484 379.861 105.953 344.552 70.4388 302.201C34.9248 259.85 28.8242 213.035 52.7907 168.799C76.7572 124.564 129.484 85.4855 202.908 57.615C276.333 29.7445 366.316 14.6687 458.914 14.6687",
      "stroke": "url(#paint1_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.62 636.746C462.62 590.427 462.402 545.596 429.939 503.344C397.693 460.993 340.391 425.684 267.184 402.772C193.977 379.861 136.893 344.552 104.43 302.201C71.9658 259.85 66.5188 213.035 88.3066 168.799C110.094 124.564 158.463 85.4855 225.352 57.615C292.458 29.7445 374.598 14.6687 458.916 14.6687",
      "stroke": "url(#paint2_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.609 636.746C462.609 590.427 462.391 545.596 433.195 503.344C404 460.993 352.145 425.684 285.91 402.772C219.675 379.861 168.038 344.552 138.625 302.201C109.429 259.85 104.2 213.035 124.027 168.799C143.854 124.564 187.429 85.4855 247.999 57.615C308.569 29.7445 382.865 14.6687 459.34 14.6687",
      "stroke": "url(#paint3_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.624 636.746C462.624 590.427 462.406 545.596 439.311 503.344C416.216 460.993 375.473 425.684 323.183 402.772C270.892 379.861 230.149 344.552 207.054 302.201C183.959 259.85 179.819 213.035 195.506 168.799C211.193 124.564 245.618 85.4855 293.333 57.615C341.266 29.7445 399.875 14.6687 460.228 14.6687",
      "stroke": "url(#paint4_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.615 636.746C462.615 590.427 462.397 545.596 442.352 503.344C422.307 460.993 387.011 425.684 341.693 402.772C296.374 379.861 261.078 344.552 241.033 302.201C220.989 259.85 217.502 213.035 231.011 168.799C244.519 124.564 274.369 85.4855 315.983 57.615C357.38 29.7445 408.363 14.6687 460.654 14.6687",
      "stroke": "url(#paint5_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.62 636.746C462.62 590.427 462.402 545.596 445.625 503.344C428.631 460.993 398.781 425.684 360.435 402.772C322.089 379.861 292.239 344.552 275.245 302.201C258.25 259.85 255.418 213.035 266.748 168.799C278.295 124.564 303.351 85.4855 338.647 57.615C373.726 29.7445 416.865 14.6687 461.094 14.6687",
      "stroke": "url(#paint6_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.616 636.746C462.616 590.427 462.398 545.596 448.672 503.344C434.727 460.993 410.325 425.684 378.951 402.772C347.576 379.861 323.174 344.552 309.23 302.201C295.286 259.85 292.889 213.035 302.258 168.799C311.626 124.564 332.325 85.4855 361.085 57.615C389.845 29.7445 424.923 14.6687 461.308 14.6687",
      "stroke": "url(#paint7_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.828 636.746C462.828 590.427 462.828 545.596 458.253 503.344C453.677 460.993 445.398 425.684 434.94 402.772C424.482 379.861 416.42 344.552 411.627 302.201C406.834 259.85 406.18 213.035 409.23 168.799C412.28 124.564 419.253 85.4855 428.839 57.615C438.426 29.7445 450.191 14.6688 462.174 14.6687",
      "stroke": "url(#paint8_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.844 636.746C462.844 590.427 462.844 545.596 461.319 503.344C459.794 460.993 456.962 425.684 453.475 402.772C449.989 379.861 447.375 344.552 445.632 302.201C444.107 259.85 443.889 213.035 444.76 168.799C445.85 124.564 448.029 85.4855 451.297 57.615C454.565 29.7445 458.487 14.6688 462.408 14.6688",
      "stroke": "url(#paint9_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 636.746C462.835 590.427 462.835 545.596 464.36 503.344C465.885 460.993 468.717 425.684 472.203 402.772C475.689 379.861 478.304 344.552 480.047 302.201C481.572 259.85 481.79 213.035 480.919 168.799C479.829 124.564 477.65 85.4855 474.382 57.615C471.114 29.7445 467.192 14.6688 463.27 14.6688",
      "stroke": "url(#paint10_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 636.746C462.835 590.427 462.835 545.596 467.41 503.344C471.986 460.993 480.265 425.684 490.723 402.772C501.181 379.861 509.243 344.552 514.036 302.201C518.829 259.849 519.483 213.035 516.433 168.799C513.382 124.564 506.41 85.4855 496.824 57.615C487.237 29.7445 475.472 14.6688 463.488 14.6688",
      "stroke": "url(#paint11_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 636.746C462.835 590.427 463.053 545.596 476.779 503.344C490.723 460.993 515.125 425.684 546.5 402.772C577.874 379.861 602.276 344.552 616.221 302.201C630.165 259.849 632.561 213.035 623.193 168.799C613.824 124.564 593.125 85.4854 564.366 57.615C535.606 29.7445 500.527 14.6688 464.142 14.6688",
      "stroke": "url(#paint12_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 636.746C462.835 590.427 463.053 545.596 479.829 503.344C496.824 460.993 526.673 425.684 565.019 402.772C603.366 379.861 633.215 344.552 650.209 302.201C667.204 259.849 670.036 213.035 658.707 168.799C647.159 124.564 622.103 85.4854 586.807 57.615C551.729 29.7445 508.589 14.6688 464.36 14.6688",
      "stroke": "url(#paint13_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 636.746C462.835 590.427 463.053 545.596 483.097 503.344C503.142 460.993 538.438 425.684 583.757 402.772C629.075 379.861 664.371 344.552 684.416 302.201C704.461 259.849 707.947 213.035 694.439 168.799C680.93 124.564 651.081 85.4854 609.466 57.615C568.07 29.7445 517.086 14.6687 464.796 14.6688",
      "stroke": "url(#paint14_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 636.746C462.835 590.427 463.053 545.596 486.148 503.344C509.243 460.993 549.986 425.684 602.276 402.772C654.567 379.861 695.31 344.552 718.405 302.201C741.5 259.849 745.64 213.035 729.953 168.799C714.265 124.564 679.841 85.4854 632.126 57.615C584.193 29.7445 525.583 14.6687 465.231 14.6688",
      "stroke": "url(#paint15_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 636.746C462.835 590.427 463.053 545.596 492.248 503.344C521.444 460.993 573.299 425.684 639.533 402.772C705.768 379.861 757.405 344.552 786.819 302.201C816.232 259.849 821.243 213.035 801.416 168.799C781.59 124.564 738.014 85.4854 677.444 57.615C616.874 29.7445 542.578 14.6687 466.103 14.6688",
      "stroke": "url(#paint16_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 636.746C462.835 590.427 463.053 545.596 495.516 503.344C527.762 460.993 585.064 425.684 658.271 402.772C731.478 379.861 788.562 344.552 821.025 302.201C853.489 259.849 858.936 213.035 837.148 168.799C815.361 124.564 766.992 85.4854 700.103 57.6149C632.997 29.7445 550.857 14.6687 466.539 14.6688",
      "stroke": "url(#paint17_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 636.746C462.835 590.427 463.053 545.596 498.567 503.344C534.081 460.993 596.611 425.684 676.79 402.772C756.969 379.861 819.5 344.552 855.014 302.201C890.528 259.849 896.629 213.035 872.662 168.799C848.696 124.564 795.969 85.4854 722.545 57.6149C649.12 29.7445 559.136 14.6687 466.539 14.6688",
      "stroke": "url(#paint18_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M462.835 636.746C462.835 590.427 463.27 545.596 501.617 503.344C540.181 460.993 608.159 425.684 695.31 402.772C782.461 379.861 850.439 344.552 889.003 302.201C927.568 259.849 934.322 213.035 908.177 168.799C882.249 124.564 824.73 85.4854 744.986 57.6149C665.243 29.7445 567.416 14.6687 466.756 14.6688",
      "stroke": "url(#paint19_linear_4887_39962)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_4887_39962",
      "x1": "231.95",
      "y1": "636.645",
      "x2": "231.95",
      "y2": "14.5681",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear_4887_39962",
      "x1": "250.52",
      "y1": "636.746",
      "x2": "250.52",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint2_linear_4887_39962",
      "x1": "268.92",
      "y1": "636.746",
      "x2": "268.92",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint3_linear_4887_39962",
      "x1": "287.4",
      "y1": "636.746",
      "x2": "287.4",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint4_linear_4887_39962",
      "x1": "324.384",
      "y1": "636.746",
      "x2": "324.383",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint5_linear_4887_39962",
      "x1": "342.773",
      "y1": "636.746",
      "x2": "342.772",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint6_linear_4887_39962",
      "x1": "361.285",
      "y1": "636.746",
      "x2": "361.285",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint7_linear_4887_39962",
      "x1": "379.632",
      "y1": "636.746",
      "x2": "379.632",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint8_linear_4887_39962",
      "x1": "435.102",
      "y1": "636.746",
      "x2": "435.102",
      "y2": "14.6688",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint9_linear_4887_39962",
      "x1": "453.547",
      "y1": "636.746",
      "x2": "453.547",
      "y2": "14.6688",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint10_linear_4887_39962",
      "x1": "472.132",
      "y1": "636.746",
      "x2": "472.131",
      "y2": "14.6688",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint11_linear_4887_39962",
      "x1": "490.561",
      "y1": "636.746",
      "x2": "490.561",
      "y2": "14.6688",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint12_linear_4887_39962",
      "x1": "545.818",
      "y1": "636.746",
      "x2": "545.818",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint13_linear_4887_39962",
      "x1": "564.17",
      "y1": "636.746",
      "x2": "564.17",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint14_linear_4887_39962",
      "x1": "582.677",
      "y1": "636.746",
      "x2": "582.677",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint15_linear_4887_39962",
      "x1": "601.076",
      "y1": "636.746",
      "x2": "601.075",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint16_linear_4887_39962",
      "x1": "638.075",
      "y1": "636.746",
      "x2": "638.074",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint17_linear_4887_39962",
      "x1": "656.535",
      "y1": "636.746",
      "x2": "656.535",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint18_linear_4887_39962",
      "x1": "674.933",
      "y1": "636.746",
      "x2": "674.933",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint19_linear_4887_39962",
      "x1": "693.332",
      "y1": "636.746",
      "x2": "693.332",
      "y2": "14.6687",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "md:hidden flex justify-center -mt-3"
  }, [_c('svg', {
    staticClass: "min-w-[800px]",
    attrs: {
      "width": "800",
      "height": "227",
      "viewBox": "0 0 800 227",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "opacity": "0.5"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask0_6943_41920",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "0",
      "width": "800",
      "height": "227"
    }
  }, [_c('rect', {
    attrs: {
      "width": "800",
      "height": "227",
      "transform": "matrix(1 0 0 -1 0 227)",
      "fill": "#C4C4C4"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#mask0_6943_41920)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M396.951 20.6692C309.8 20.6692 225.29 42.0581 156.059 81.5993C87.0177 121.141 37.2171 176.583 14.7691 239.342C-7.67888 302.102 -2.01974 368.66 31.3693 428.605C64.7583 488.55 123.614 538.786 199.069 571.291C274.524 603.797 333.38 653.892 366.769 713.977C400.158 774.063 400.346 837.526 400.346 903.241",
      "stroke": "url(#paint0_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.535 903.383C400.535 837.669 400.347 774.065 369.599 714.12C338.851 654.034 284.711 603.939 215.292 571.434C145.873 538.929 91.7341 488.834 60.986 428.748C30.238 368.662 24.9561 302.244 45.7063 239.485C66.4565 176.725 112.107 121.283 175.678 81.7419C239.249 42.2006 317.157 20.8118 397.328 20.8118",
      "stroke": "url(#paint1_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.537 903.383C400.537 837.669 400.348 774.065 372.241 714.12C344.323 654.034 294.711 603.939 231.328 571.434C167.946 538.929 118.522 488.834 90.4152 428.748C62.3081 368.662 57.5921 302.244 76.456 239.485C95.3198 176.725 137.198 121.283 195.11 81.7419C253.21 42.2006 324.327 20.8119 397.33 20.8118",
      "stroke": "url(#paint2_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.527 903.383C400.527 837.669 400.338 774.065 375.061 714.12C349.783 654.034 304.887 603.939 247.541 571.434C190.195 538.929 145.487 488.834 120.021 428.748C94.7436 368.662 90.2162 302.244 107.382 239.485C124.548 176.725 162.276 121.283 214.718 81.7419C267.159 42.2006 331.485 20.8119 397.697 20.8118",
      "stroke": "url(#paint3_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.534 903.384C400.534 837.669 400.345 774.065 377.709 714.12C355.072 654.035 314.892 603.94 263.582 571.434C212.272 538.929 172.281 488.834 149.456 428.748C126.819 368.662 122.858 302.244 138.137 239.485C153.417 176.726 187.183 121.283 234.155 81.7421C281.126 42.2009 338.66 20.8121 397.893 20.8121",
      "stroke": "url(#paint4_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.54 903.384C400.54 837.669 400.352 774.065 380.356 714.12C360.36 654.035 325.085 603.94 279.812 571.434C234.538 538.929 199.263 488.834 179.267 428.748C159.272 368.662 155.687 302.244 169.269 239.485C182.851 176.726 212.656 121.283 253.968 81.7421C295.469 42.2009 346.212 20.8121 398.465 20.8121",
      "stroke": "url(#paint5_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.532 903.384C400.532 837.669 400.344 774.065 382.989 714.12C365.634 654.035 335.075 603.94 295.838 571.434C256.601 538.929 226.042 488.834 208.687 428.748C191.332 368.662 188.314 302.244 200.009 239.485C211.705 176.726 237.549 121.283 273.579 81.7422C309.42 42.2009 353.561 20.8121 398.835 20.8121",
      "stroke": "url(#paint6_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.536 903.383C400.536 837.669 400.348 774.065 385.823 714.12C371.109 654.034 345.265 603.939 312.065 571.434C278.865 538.929 253.021 488.834 238.307 428.748C223.593 368.662 221.141 302.244 230.95 239.485C240.948 176.725 262.642 121.283 293.201 81.7419C323.572 42.2007 360.922 20.8119 399.216 20.8119",
      "stroke": "url(#paint7_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.533 903.383C400.533 837.669 400.344 774.065 388.46 714.12C376.387 654.034 355.26 603.939 328.096 571.434C300.932 538.929 279.804 488.834 267.731 428.748C255.658 368.662 253.583 302.244 261.695 239.485C269.806 176.725 287.727 121.283 312.627 81.7419C337.528 42.2007 367.898 20.8119 399.401 20.8119",
      "stroke": "url(#paint8_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.721 903.383C400.721 837.669 400.721 774.065 391.289 714.12C382.045 654.034 365.445 603.939 344.318 571.434C323.19 538.929 306.779 488.834 297.347 428.748C288.103 368.662 286.406 302.244 292.631 239.485C298.856 176.725 312.815 121.283 332.245 81.7419C351.674 42.2007 375.254 20.8119 399.589 20.8119",
      "stroke": "url(#paint9_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.724 903.384C400.724 837.669 400.724 774.066 393.933 714.12C387.331 654.035 375.446 603.94 360.355 571.434C345.264 538.929 333.569 488.834 326.778 428.748C319.987 368.662 318.855 302.244 323.382 239.485C327.909 176.726 337.907 121.283 351.678 81.7422C365.449 42.2009 382.426 20.8122 399.781 20.8122",
      "stroke": "url(#paint10_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.717 903.384C400.717 837.669 400.717 774.066 396.756 714.12C392.794 654.035 385.626 603.94 376.571 571.434C367.517 538.929 360.537 488.834 356.387 428.748C352.237 368.662 351.671 302.244 354.312 239.485C356.953 176.726 362.989 121.283 371.289 81.7422C379.589 42.2009 389.776 20.8122 400.151 20.8122",
      "stroke": "url(#paint11_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.731 903.384C400.731 837.669 400.731 774.066 399.41 714.12C398.09 654.035 395.638 603.94 392.619 571.434C389.601 538.929 387.338 488.834 385.828 428.748C384.508 368.662 384.319 302.244 385.074 239.485C386.017 176.726 387.903 121.283 390.733 81.7422C393.563 42.201 396.958 20.8122 400.354 20.8122",
      "stroke": "url(#paint12_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 400.723 774.066 402.043 714.12C403.364 654.035 405.816 603.94 408.834 571.434C411.852 538.929 414.116 488.834 415.625 428.748C416.946 368.662 417.134 302.244 416.38 239.485C415.436 176.726 413.55 121.283 410.72 81.7422C407.891 42.201 404.495 20.8122 401.1 20.8122",
      "stroke": "url(#paint13_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 400.723 774.066 404.684 714.12C408.645 654.035 415.814 603.94 424.868 571.434C433.923 538.929 440.903 488.834 445.053 428.748C449.203 368.662 449.769 302.244 447.128 239.485C444.487 176.726 438.45 121.283 430.15 81.7422C421.85 42.2009 411.664 20.8122 401.288 20.8122",
      "stroke": "url(#paint14_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 400.723 774.066 407.514 714.12C414.116 654.035 426 603.94 441.091 571.434C456.182 538.929 467.878 488.834 474.669 428.748C481.46 368.662 482.592 302.244 478.064 239.485C473.537 176.726 463.539 121.283 449.769 81.7422C435.998 42.2009 419.021 20.8122 401.666 20.8122",
      "stroke": "url(#paint15_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 400.723 774.066 410.155 714.12C419.398 654.035 435.998 603.94 457.126 571.434C478.253 538.929 494.665 488.834 504.097 428.748C513.34 368.662 515.038 302.244 508.813 239.485C502.587 176.726 488.628 121.283 469.198 81.7422C449.769 42.2009 426.189 20.8122 401.854 20.8122",
      "stroke": "url(#paint16_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 400.911 774.066 412.796 714.12C424.868 654.035 445.996 603.94 473.16 571.434C500.324 538.929 521.451 488.834 533.524 428.748C545.597 368.662 547.672 302.244 539.561 239.485C531.449 176.726 513.528 121.283 488.628 81.7422C463.728 42.2009 433.357 20.8122 401.854 20.8122",
      "stroke": "url(#paint17_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 400.911 774.066 415.436 714.12C430.15 654.035 455.994 603.94 489.194 571.434C522.395 538.929 548.238 488.834 562.952 428.748C577.666 368.662 580.118 302.244 570.309 239.485C560.311 176.726 538.617 121.283 508.058 81.7421C477.687 42.2009 440.337 20.8122 402.043 20.8122",
      "stroke": "url(#paint18_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 400.911 774.066 418.266 714.12C435.621 654.035 466.18 603.94 505.417 571.434C544.654 538.929 575.213 488.834 592.568 428.748C609.923 368.662 612.941 302.244 601.245 239.485C589.55 176.726 563.706 121.283 527.676 81.7421C491.835 42.2009 447.694 20.8122 402.42 20.8122",
      "stroke": "url(#paint19_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 400.911 774.066 420.907 714.12C440.903 654.035 476.178 603.94 521.451 571.434C566.725 538.929 602 488.834 621.996 428.748C641.991 368.662 645.576 302.244 631.994 239.485C618.412 176.725 588.607 121.283 547.295 81.7421C505.794 42.2009 455.05 20.8122 402.798 20.8122",
      "stroke": "url(#paint20_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 400.911 774.066 423.548 714.12C446.184 654.035 486.365 603.94 537.674 571.434C588.984 538.929 628.975 488.834 651.801 428.748C674.437 368.662 678.399 302.244 663.119 239.485C647.839 176.725 614.073 121.283 567.102 81.7421C520.131 42.2009 462.596 20.8122 403.364 20.8122",
      "stroke": "url(#paint21_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 400.911 774.066 426.189 714.12C451.466 654.035 496.362 603.94 553.708 571.434C611.055 538.929 655.762 488.834 681.228 428.748C706.694 368.662 711.033 302.244 693.867 239.485C676.701 176.725 638.973 121.283 586.532 81.7421C534.09 42.2009 469.764 20.8122 403.552 20.8122",
      "stroke": "url(#paint22_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 400.911 774.066 429.018 714.12C456.937 654.035 506.549 603.94 569.931 571.434C633.314 538.929 682.737 488.834 710.844 428.748C738.952 368.662 743.668 302.244 724.804 239.485C705.94 176.725 664.062 121.283 606.15 81.7421C548.049 42.2009 476.933 20.8122 403.929 20.8122",
      "stroke": "url(#paint23_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 400.911 774.066 431.659 714.12C462.407 654.035 516.547 603.94 585.966 571.434C655.385 538.929 709.524 488.834 740.272 428.748C771.02 368.662 776.302 302.244 755.552 239.485C734.801 176.725 689.151 121.283 625.58 81.7421C562.008 42.2009 484.101 20.8122 403.929 20.8122",
      "stroke": "url(#paint24_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M400.723 903.384C400.723 837.669 401.1 774.066 434.3 714.12C467.689 654.035 526.545 603.94 602 571.434C677.456 538.929 736.311 488.834 769.7 428.748C803.089 368.662 808.937 302.244 786.3 239.485C763.852 176.725 714.051 121.283 645.01 81.7421C575.968 42.2009 491.269 20.8122 404.118 20.8122",
      "stroke": "url(#paint25_linear_6943_41920)",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_6943_41920",
      "x1": "200.823",
      "y1": "903.241",
      "x2": "200.822",
      "y2": "20.6692",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear_6943_41920",
      "x1": "216.9",
      "y1": "903.383",
      "x2": "216.9",
      "y2": "20.8119",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint2_linear_6943_41920",
      "x1": "232.831",
      "y1": "903.383",
      "x2": "232.831",
      "y2": "20.8119",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint3_linear_6943_41920",
      "x1": "248.831",
      "y1": "903.383",
      "x2": "248.831",
      "y2": "20.8119",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint4_linear_6943_41920",
      "x1": "264.768",
      "y1": "903.384",
      "x2": "264.767",
      "y2": "20.8121",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint5_linear_6943_41920",
      "x1": "280.851",
      "y1": "903.384",
      "x2": "280.851",
      "y2": "20.8121",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint6_linear_6943_41920",
      "x1": "296.773",
      "y1": "903.384",
      "x2": "296.772",
      "y2": "20.8122",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint7_linear_6943_41920",
      "x1": "312.801",
      "y1": "903.383",
      "x2": "312.8",
      "y2": "20.8119",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint8_linear_6943_41920",
      "x1": "328.686",
      "y1": "903.383",
      "x2": "328.685",
      "y2": "20.8119",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint9_linear_6943_41920",
      "x1": "344.83",
      "y1": "903.383",
      "x2": "344.829",
      "y2": "20.8119",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint10_linear_6943_41920",
      "x1": "360.695",
      "y1": "903.384",
      "x2": "360.695",
      "y2": "20.8122",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint11_linear_6943_41920",
      "x1": "376.712",
      "y1": "903.384",
      "x2": "376.711",
      "y2": "20.8122",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint12_linear_6943_41920",
      "x1": "392.682",
      "y1": "903.384",
      "x2": "392.681",
      "y2": "20.8122",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint13_linear_6943_41920",
      "x1": "408.772",
      "y1": "903.384",
      "x2": "408.771",
      "y2": "20.8122",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint14_linear_6943_41920",
      "x1": "424.728",
      "y1": "903.384",
      "x2": "424.728",
      "y2": "20.8122",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint15_linear_6943_41920",
      "x1": "440.752",
      "y1": "903.384",
      "x2": "440.751",
      "y2": "20.8122",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint16_linear_6943_41920",
      "x1": "456.613",
      "y1": "903.384",
      "x2": "456.613",
      "y2": "20.8122",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint17_linear_6943_41920",
      "x1": "472.57",
      "y1": "903.384",
      "x2": "472.569",
      "y2": "20.8122",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint18_linear_6943_41920",
      "x1": "488.458",
      "y1": "903.384",
      "x2": "488.458",
      "y2": "20.8122",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint19_linear_6943_41920",
      "x1": "504.482",
      "y1": "903.384",
      "x2": "504.482",
      "y2": "20.8122",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint20_linear_6943_41920",
      "x1": "520.412",
      "y1": "903.384",
      "x2": "520.411",
      "y2": "20.8121",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint21_linear_6943_41920",
      "x1": "536.489",
      "y1": "903.384",
      "x2": "536.489",
      "y2": "20.8121",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint22_linear_6943_41920",
      "x1": "552.445",
      "y1": "903.384",
      "x2": "552.445",
      "y2": "20.8121",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint23_linear_6943_41920",
      "x1": "568.428",
      "y1": "903.384",
      "x2": "568.428",
      "y2": "20.8121",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint24_linear_6943_41920",
      "x1": "584.358",
      "y1": "903.384",
      "x2": "584.357",
      "y2": "20.8121",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint25_linear_6943_41920",
      "x1": "600.287",
      "y1": "903.384",
      "x2": "600.287",
      "y2": "20.8121",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#C7DEF0",
      "stop-opacity": "0.81"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.296875",
      "stop-color": "#76AEDA",
      "stop-opacity": "0.58"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.651042",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.953125",
      "stop-color": "#D7E7F4",
      "stop-opacity": "0.28"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "hidden md:grid grid-cols-5 md:gap-x-4 xl:gap-x-[58.75px] mb-48 -mt-4 xl:mt-0"
  }, _vm._l(_vm.blok.logos, function (logo, i) {
    var _logo$link, _logo$link2, _logo$link3, _logo$link4, _logo$icon, _logo$icon2;
    return _c('div', {
      key: logo._uid,
      staticClass: "relative"
    }, [_c(logo !== null && logo !== void 0 && (_logo$link = logo.link) !== null && _logo$link !== void 0 && _logo$link.cached_url ? 'a' : 'div', {
      tag: "component",
      staticClass: "bg-white w-full rounded-2xl shadow-1 flex justify-center hover:bg-gray-100 ease-in-out duration-200 p-2",
      class: {
        'lg:cursor-pointer hover:transform hover:shadow-lift hover:scale-105': logo === null || logo === void 0 ? void 0 : (_logo$link2 = logo.link) === null || _logo$link2 === void 0 ? void 0 : _logo$link2.cached_url
      },
      attrs: {
        "href": logo !== null && logo !== void 0 && (_logo$link3 = logo.link) !== null && _logo$link3 !== void 0 && _logo$link3.cached_url ? logo.link.cached_url : undefined,
        "target": logo !== null && logo !== void 0 && (_logo$link4 = logo.link) !== null && _logo$link4 !== void 0 && _logo$link4.cached_url ? logo.link_target : undefined,
        "rel": logo.link_target === '_blank' ? 'noopener noreferrer' : undefined
      },
      on: {
        "mouseenter": function (e) {
          return _vm.enter(e, i);
        }
      }
    }, [_c('div', {
      staticClass: "aspect-w-2 aspect-h-1 w-full h-full"
    }, [_c('img', {
      staticClass: "object-contain mx-auto",
      style: {
        maxWidth: logo.icon_width
      },
      attrs: {
        "src": (_logo$icon = logo.icon) === null || _logo$icon === void 0 ? void 0 : _logo$icon.filename,
        "alt": (_logo$icon2 = logo.icon) === null || _logo$icon2 === void 0 ? void 0 : _logo$icon2.filename
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "absolute py-4 px-5 w-[340px] mt-4",
      class: {
        'left-0': i === 0,
        'right-0': i === _vm.blok.logos.length - 1,
        'left-1/2 -translate-x-1/2': i !== 0 && i !== _vm.blok.logos.length - 1
      },
      attrs: {
        "data-index": i
      }
    }, [logo.popover.length ? _c('StoryblokComponent', {
      staticClass: "z-10 relative content",
      attrs: {
        "blok": logo.popover[0]
      }
    }) : _vm._e(), _vm._v(" "), i === 0 ? _c('div', {
      ref: "tooltipRef",
      refInFor: true,
      staticClass: "absolute inset-0 w-full h-full bg-white rounded-md"
    }) : _vm._e()], 1), _vm._v(" "), i === 0 ? _c('svg', {
      ref: "arrowRef",
      refInFor: true,
      staticClass: "absolute left-1/2 -translate-x-1/2 bottom-[-17px]",
      attrs: {
        "width": "27",
        "height": "12",
        "viewBox": "0 0 27 12",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M9.25736 2.24264L0 11.5H27L17.7426 2.24264C15.3995 -0.100505 11.6005 -0.100502 9.25736 2.24264Z",
        "fill": "white"
      }
    })]) : _vm._e()], 1);
  }), 0), _vm._v(" "), _c('ModulesLayoutsSliderLayout', {
    staticClass: "md:hidden -mt-8 mb-8",
    attrs: {
      "blok": {
        progress_bar_color: 'transparent',
        progress_handle_color: 'rgba(101, 197, 221, .5)'
      }
    }
  }, _vm._l(_vm.blok.logos, function (logo) {
    var _logo$link5, _logo$link6, _logo$link7, _logo$icon3, _logo$icon4;
    return _c('div', {
      key: logo._uid,
      staticClass: "relative slide flex mr-8 last:mr-0"
    }, [_c(logo !== null && logo !== void 0 && (_logo$link5 = logo.link) !== null && _logo$link5 !== void 0 && _logo$link5.cached_url ? 'a' : 'div', {
      tag: "component",
      staticClass: "bg-white mx-auto rounded-2xl shadow-1 grid grid-cols-1 p-2 w-[340px]",
      attrs: {
        "href": logo === null || logo === void 0 ? void 0 : (_logo$link6 = logo.link) === null || _logo$link6 === void 0 ? void 0 : _logo$link6.cached_url,
        "target": logo === null || logo === void 0 ? void 0 : (_logo$link7 = logo.link) === null || _logo$link7 === void 0 ? void 0 : _logo$link7.cached_url,
        "rel": logo.link_target === '_blank' ? 'noopener noreferrer' : undefined
      }
    }, [_c('div', {
      staticClass: "aspect-w-3 aspect-h-1 w-full h-full row-span-1"
    }, [_c('img', {
      staticClass: "object-contain mx-auto",
      style: {
        maxWidth: logo.icon_width
      },
      attrs: {
        "src": (_logo$icon3 = logo.icon) === null || _logo$icon3 === void 0 ? void 0 : _logo$icon3.filename,
        "alt": (_logo$icon4 = logo.icon) === null || _logo$icon4 === void 0 ? void 0 : _logo$icon4.filename
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "whitespace-pre-wrap place-self-center row-span-3 px-3 pb-3"
    }, [logo.popover.length ? _c('StoryblokComponent', {
      attrs: {
        "blok": logo.popover[0]
      }
    }) : _vm._e()], 1)])], 1);
  }), 0)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }